<template>
  <Background :theme="microSiteHeroContent?.background">
    <div :class="sectionClasses">
      <div
        :class="{
          'container mx-auto px-0 pt-5': true,
        }"
      >
        <PortableText
          v-if="microSiteHeroContent?.Content?.footerPortableText"
          :portable-data="microSiteHeroContent?.Content.footerPortableText"
        />
        <MicroSiteNavigation
          v-if="microSiteHeroContent?.microSiteNavigation"
          v-bind="microSiteHeroContent?.microSiteNavigation"
          :class="{
            'mb-10': true,
          }"
        />
      </div>
    </div>
  </Background>
</template>

<script lang="ts" setup>
import MicroSiteNavigation from '~/components/Atmos/MicroSiteNavigation/MicroSiteNavigation.vue';
import Background from '~/components/Atmos/Background/Background.vue';
import PortableText from '~/components/Atmos/PortableText/PortableText.vue';
import type { MicroSiteQueryResult } from '~/sanity/types';
type MicroSiteHeroProps = {
  microSiteHero: NonNullable<MicroSiteQueryResult>['MicroSiteHeroContent'];
};
const props = defineProps<MicroSiteHeroProps>();
const { microSiteHeroContent } = props.microSiteHero;
const paddingTop = computed(() => microSiteHeroContent?.paddingTop ?? 'default');
const paddingBottom = computed(() => microSiteHeroContent?.paddingBottom ?? 'default');

const paddingTopClass = computed(() => {
  return paddingTopClasses[paddingTop.value ?? 'default'] ?? paddingTopClasses['default'];
});
const paddingBottomClass = computed(() => {
  return paddingBottomClasses[paddingBottom.value ?? 'default'] ?? paddingBottomClasses['default'];
});
const sectionClasses = computed(() => [
  'padding-wrapper',
  paddingTopClass.value,
  paddingBottomClass.value,
]);
const paddingTopClasses: Record<string, string> = {
  default: 'pt-5',
  '20px': 'pt-5',
  '40px': 'pt-10',
  '80px': 'pt-20',
  '100px': 'pt-100px',
  '120px': 'pt-120px',
  '200px': 'pt-200px',
  '0px': 'pt-0',
};
const paddingBottomClasses: Record<string, string> = {
  default: 'pb-5',
  '20px': 'pb-5',
  '40px': 'pb-10',
  '80px': 'pb-20',
  '100px': 'pb-100px',
  '120px': 'pb-120px',
  '200px': 'pb-200px',
  '0px': 'pb-0',
};
</script>

<style></style>
